const apiUrl = process.env.REACT_APP_API_URL;

export default class WishlistService {
  static getWishlist() {
    return fetch(`${apiUrl}/api/wishlist/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static getWishlistView() {
    return fetch(`${apiUrl}/api/wishlist/view/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static setWishlist(product_id: number) {
    return fetch(`${apiUrl}/api/wishlist/`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({ product_id: product_id }),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static handleError(error: Error): void {
    console.error("error", error);
  }
}
